import { z } from 'zod';
import { ADDRESS_CONSTRAINTS } from '../address/constraints.js';
import { optionalFormString, optionalFormTrimmedString } from '../zod-helpers/index.js';
import { addAddressIssues } from './address-form-rules.js';
import { locationGroupNameSchema } from './create-form.js';
export const locationGroupEditFormSchema = z
    .object({
    name: locationGroupNameSchema,
    // WHY: not an editable control -- carried so addAddressIssues can tell an active warehouse
    // (address required) from an inactive one (all-or-nothing).
    activeFlag: z.boolean(),
    // WHY: also not a control -- blanking every field would be a delete, which the API has no
    // mutation for, so the form requires a replacement rather than accepting a silent no-op.
    hasSavedAddress: z.boolean(),
    address: optionalFormTrimmedString(ADDRESS_CONSTRAINTS.address.maxLength),
    city: optionalFormTrimmedString(ADDRESS_CONSTRAINTS.city.maxLength),
    stateId: optionalFormString(),
    countryId: optionalFormString(),
    zip: optionalFormTrimmedString(ADDRESS_CONSTRAINTS.zip.maxLength),
})
    .superRefine(addAddressIssues);
//# sourceMappingURL=update-form.js.map